<!--
 * @Author: czj
 * @Date: 2025-04-12 16:14:21
 * @Description: 
 * @FilePath: \test-demo2\src\components\ContentCom\comps\TextCom.vue
-->
<template>
  <div v-if="props.data"></div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  const emit = defineEmits([])
  const props = defineProps(['data']);

  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped></style>